module.exports = __webpack_public_path__ + "static/media/2.634b17e9.jpg";